import { PayloadAction } from '@reduxjs/toolkit';

import { LayoutSchema, LayoutsState } from 'editor/src/store/editorModules/layouts/types';

const setLayoutsReducer = (state: LayoutsState, action: PayloadAction<LayoutSchema[]>) => {
  state.schemas = action.payload;
};

export default setLayoutsReducer;
